import type { ConfigSection } from "@eweadn-qiankun/shared-types";
import type { CommunityPreviewDeviceMeta } from "@eweadn-qiankun/shared-types";
import CommunityPreviewStage from "./CommunityPreviewStage";
import MouseChangeKeySection from "./panels/MouseChangeKeySection";
import MouseDpiSection from "./panels/MouseDpiSection";
import MouseDynamicSensitivitySection from "./panels/MouseDynamicSensitivitySection";
import MouseTriggerSection from "./panels/MouseTriggerSection";
import MousePerformanceSection from "./panels/MousePerformanceSection";
import MouseParameterSection from "./panels/MouseParameterSection";
import MouseLightingSection from "./panels/MouseLightingSection";

export interface CommunityMousePreviewProps {
  meta: CommunityPreviewDeviceMeta;
  configData: Record<string, unknown>;
  activeSection: ConfigSection;
  readOnly?: boolean;
}

/** 鼠标配置只读预览（对齐技术方案 CommunityMousePreview） */
export default function CommunityMousePreview({
  meta,
  configData,
  activeSection,
  readOnly: _readOnly = true,
}: CommunityMousePreviewProps) {
  const section = (() => {
    switch (activeSection) {
      case "changeKey":
        return <MouseChangeKeySection meta={meta} configData={configData} />;
      case "dpi":
        return <MouseDpiSection meta={meta} configData={configData} />;
      case "trigger":
        if (meta.solutionProvider === "zhanli") return null;
        return <MouseTriggerSection meta={meta} configData={configData} />;
      case "dynamicSensitivity":
        if (meta.solutionProvider !== "zhanli") return null;
        return (
          <MouseDynamicSensitivitySection meta={meta} configData={configData} />
        );
      case "performance":
        return <MousePerformanceSection meta={meta} configData={configData} />;
      case "parameter":
        return <MouseParameterSection meta={meta} configData={configData} />;
      case "lighting":
        return <MouseLightingSection meta={meta} configData={configData} />;
      default:
        return null;
    }
  })();

  return <CommunityPreviewStage>{section}</CommunityPreviewStage>;
}
